import { render } from "./CoursesList.vue?vue&type=template&id=66592b36"
import script from "./CoursesList.vue?vue&type=script&lang=js"
export * from "./CoursesList.vue?vue&type=script&lang=js"
script.render = render

export default script